// Pure helper for the "auto-archive cancelled deals after 2 weeks" feature.
// No React, no Firestore — it just decides WHICH deals are due to be archived.
// The caller is responsible for actually flipping `archived` in Firestore.

export const TWO_WEEKS_MS = 14 * 24 * 60 * 60 * 1000;

/**
 * Given the full deal list and the current time (ms since epoch), return the
 * ids of deals that should be auto-archived.
 *
 * A deal is due when ALL of:
 *   - its stage is "Cancelled" (case-insensitive)
 *   - it is not already archived
 *   - it is not soft-deleted
 *   - AND either it has no `cancelledAt` (a deal cancelled before this feature
 *     existed — treated as overdue) OR it was cancelled 2+ weeks ago.
 */
export function getDealsToAutoArchive(deals, nowMs) {
  return (deals || [])
    .filter((d) => {
      if (!d) return false;
      if (String(d.dealStage).toLowerCase() !== "cancelled") return false;
      if (d.archived) return false;
      if (typeof d.deletedAt === "number" && d.deletedAt > 0) return false;
      const cancelledAt = Number(d.cancelledAt);
      if (!cancelledAt) return true; // legacy already-cancelled → overdue
      return nowMs - cancelledAt >= TWO_WEEKS_MS;
    })
    .map((d) => d.id ?? d.createdat)
    .filter((id) => id != null);
}
